import { render, staticRenderFns } from "./SwiperIndexView.vue?vue&type=template&id=e5020876&scoped=true"
import script from "./SwiperIndexView.vue?vue&type=script&lang=js"
export * from "./SwiperIndexView.vue?vue&type=script&lang=js"
import style0 from "./SwiperIndexView.vue?vue&type=style&index=0&id=e5020876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5020876",
  null
  
)

export default component.exports